<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>

<div class="w-full h-full bg-gradient-to-r from-gray-200 to-gray-300">
  <div class="container items-center justify-center rounded-sm shadow-lg pb-12 pt-12">
    <div class="flex items-center justify-center text-center pt-10" style="justify-content: center;margin-left:40px">
      <img src="assets/images/O3sigma_logo_blue.png" style="width:16rem;" alt="O3 Smart Manufacturing"
        class="w-64 p-3 rounded" />
    </div>
    <form class="flex flex-row justify-center mt-20" [formGroup]="form">
      <div class="flex column ml-auto mr-auto w-1/5" style="justify-content: center;">
        <mat-form-field appearance="outline">
          <mat-label class="field-label">Your Email</mat-label>
          <input matInput type="email" placeholder="Enter Your Email " formControlName="email" autocomplete="email" />
          <mat-error *ngIf="form.invalid && form.get('email').hasError('required')"> Required
          </mat-error>
          <mat-error *ngIf="form.invalid && form.get('email').hasError('invalidEmail')">Invalid Email</mat-error>
        </mat-form-field>
      </div>
    </form>
    <div class="flex justify-center gap-1 mb-6">
       <button *ngIf="!isSignInEnabled" mat-raised-button color="primary" [class.disabled]="!form.valid" (click)="confirmEmailClick()">Confirm Your Email</button>
      <!-- <button class="text-white mt-4" mat-flat-button type="button" (click)="confirmEmailClick()"
        [disabled]="!form.valid" >
        Confirm Your Email
      </button> -->
      <button mat-flat-button color="primary" class="mt-4 text-white" type="button" *ngIf="isSignInEnabled" (click)="goToLogin()">
        Sign In
      </button>
    </div>
    <app-dismiss-alert *ngIf="successOrErrorMessage" [message]="successOrErrorMessage"
      [isError]="isError"></app-dismiss-alert>
  </div>
</div>